import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { EmbeddedVideo, HTMLParser, KeepProportions, StepCard, StepCardGroup } from '@gik/ui';
import { UIFeaturesType } from '@gik/ui/types';

export interface ICareCalendarAsideProps {
  featureVideo: string;
  trackCalendarVideoPlayed?: () => void;
}

const blockName = 'care-calendar-aside';

export default function CareCalendarAside({ featureVideo, trackCalendarVideoPlayed }: ICareCalendarAsideProps) {
  const bem = bemBlock(blockName);

  return (
    <div className={bem()}>
      <div className={bem('title')}>{i18n.t(translationKeys.careCalendarHowItWorksTitle)}</div>
      <StepCardGroup>
        <StepCard type={UIFeaturesType.CareCalendar}>
          <HTMLParser rawHtml={i18n.t(translationKeys.careCalendarHowItWorksDescription1)} />
        </StepCard>
        <StepCard type={UIFeaturesType.CareCalendar}>
          <HTMLParser rawHtml={i18n.t(translationKeys.careCalendarHowItWorksDescription2)} />
        </StepCard>
      </StepCardGroup>

      <KeepProportions className={bem('video')}>
        <EmbeddedVideo
          url={`https://www.youtube.com/watch?v=${featureVideo}`}
          lightboxOverlay
          lightboxTitle={i18n.t(translationKeys.careCalendarTitle)}
          trackFunction={trackCalendarVideoPlayed}
        />
      </KeepProportions>
    </div>
  );
}
